import { render, staticRenderFns } from "./Shading.vue?vue&type=template&id=01a7f7f1&"
import script from "./Shading.vue?vue&type=script&lang=js&"
export * from "./Shading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports